<template>
  <div>
    <section class="section auth-ui-section--has-margin-top auth-ui-section--is-narrow">
      <div class="container auth-ui-container--has-centered-content">
        <v-card :classes="'auth-ui-card--is-not-full-width'">
          <div slot="header-title">
            {{ $t('auth.notFoundTitle') }}
          </div>
          <div slot="body">
            {{ $t('auth.notFoundDescription') }}

            {{ $t('auth.sessionExpirationDescription') }}
          </div>
        </v-card>
      </div>
    </section>
  </div>
</template>

<script>
/* ============
 * Not Found Page
 * ============
 *
 * This is shown when whenever 404 happens.
 */

import VCard from '../../components/Card.vue';

export default {
  name: 'GeneralNotFound',

  components: {
    VCard,
  },
};
</script>
